import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminHeader from '../components/layout/AdminHeader';
import AdminSidebar from '../components/layout/AdminSidebar';
import SidebarNavigation from '../components/layout/SidebarNavigation';
import Drawer from '../components/common/Drawer';
import useLocalStorage from '../hooks/useLocalStorage';
import { classNames } from '../utils/classNames';

function AdminLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage('sidebar-collapsed', false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-surface-page">
      <AdminSidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed((value) => !value)}
      />
      <div className={classNames('min-h-screen transition-[padding] duration-300', sidebarCollapsed ? 'lg:pl-[76px]' : 'lg:pl-64')}>
        <AdminHeader
          sidebarCollapsed={sidebarCollapsed}
          onToggleSidebar={() => setSidebarCollapsed((value) => !value)}
          onOpenMobileMenu={() => setMobileMenuOpen(true)}
        />
        <main className="px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
          <div className="mx-auto max-w-content">
            <Outlet />
          </div>
        </main>
      </div>

      <Drawer
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        side="left"
        title="Navegación"
        description="Votum · Panel administrativo"
      >
        <SidebarNavigation
          theme="light"
          onNavigate={() => setMobileMenuOpen(false)}
        />
      </Drawer>
    </div>
  );
}

export default AdminLayout;
